import { Icon, Typography } from "@outschool/backpack";
import { fasExclamationTriangle } from "@outschool/icons";
import React from "react";

type LearnerFormWarningProps = {
  message: string;
};

export function LearnerFormWarning({ message }: LearnerFormWarningProps) {
  return (
    <Typography
      sx={{
        marginTop: "8px",
        fontSize: 14,
        role: "alert"
      }}
      component="p"
    >
      <Icon
        icon={fasExclamationTriangle}
        color="error"
        sx={{
          fontSize: "1em",
          marginTop: "3px",
          marginRight: "6px",
          float: "left"
        }}
      />
      {message}
    </Typography>
  );
}
